import { TimesheetReason } from '@bechtel/types';
import { ErrorRetry } from '@bechtel/client-common';
import { find, get } from 'lodash';
import { Box, Text, Select, FormControl, TextFieldSize, TextFieldAppearance, TextArea } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { FC } from 'react';
import { useTimeSheetReason } from '~/hooks';
import { AddCommentProps } from './types';
import { CommentMessages } from '~/components/atoms';
import { TimesheetReasons } from '~/detail/types';

const DropdownItem = ({ item }: { item: TimesheetReason }) => {
  return (
    <Text size="400" color="grey.1000">
      <Trans id={CommentMessages[item.name].message} />
    </Text>
  );
};

export const AddComment: FC<AddCommentProps> = ({ comment, reason, setComment, setReason }) => {
  const { loading, error, data, refetch } = useTimeSheetReason();
  const reasonList = get(data, 'timesheetReasons', []);
  const otherReasonId = find(reasonList, (reason) => reason.name == TimesheetReasons.TIMESHEET_REASON_OTHER)?.id;

  return (
    <Box flexDirection={{ sm: 'column' }} gap={{ sm: '600' }} flexGrow={{ sm: 1 }}>
      {!loading && error && (
        <div data-testid="reason-error">
          <ErrorRetry refetch={refetch}>
            <Trans>There was a problem loading the list.</Trans>
          </ErrorRetry>
        </div>
      )}
      {!error && (
        <FormControl
          label={
            <Text family="graphik" size="300" color="bechtel.blue.800">
              <Trans>Reason (Required)</Trans>
            </Text>
          }
        >
          <Select
            name="reason"
            size={TextFieldSize.LARGE}
            appearance={TextFieldAppearance.NORMAL}
            items={reasonList}
            selectedItem={find(reasonList, (item) => item.id === reason)}
            itemComponent={DropdownItem}
            selectedComponent={DropdownItem}
            loading={loading}
            onSelectedItemChange={(changes: any) => {
              setReason(changes.selectedItem);
            }}
          />
        </FormControl>
      )}
      <TextArea
        data-testid="comments"
        maxLength={2000}
        placeholder="Add a comment…"
        size={TextFieldSize.LARGE}
        rows="8"
        disabled={reason !== otherReasonId}
        value={reason === otherReasonId ? comment : ''}
        maxlength={2000}
        onChange={(e) => setComment(e.target.value)}
      />
    </Box>
  );
};
